import { Box } from "@mui/material";
import {
  useAchievements,
  useSkipAchievementStep,
} from "../../hooks/useCustomQuery";
import AchievementRow from "./AchievementRow";

/**
 * The "Getting started" checklist row, unheaded at the top of the dashboard:
 * a short onboarding task list, gone once earned or every remaining step is
 * skipped. Shares useAchievements with DashboardProgress (one request). Shows
 * nothing while loading or on error, rather than a placeholder for a row that
 * may not exist — DashboardProgress surfaces the error.
 */
export default function DashboardGettingStarted({ contentType }) {
  const { data } = useAchievements(contentType);
  const skipStep = useSkipAchievementStep(contentType);
  const row = data?.find((r) => r.kind === "checklist");

  if (!row) return null;

  return (
    <Box>
      <AchievementRow
        row={row}
        onSkip={(stepKey) => skipStep.mutate(stepKey)}
      />
    </Box>
  );
}
